/** Stateless (props only), so the unit is a View plus this wrapper. */
import NoticeCardView from './View';

export type {NoticeCardProps} from './View';
export default NoticeCardView;
